import { render, staticRenderFns } from "./PointsQuota.vue?vue&type=template&id=9fce2250&scoped=true"
import script from "./PointsQuota.vue?vue&type=script&lang=js"
export * from "./PointsQuota.vue?vue&type=script&lang=js"
import style0 from "./PointsQuota.vue?vue&type=style&index=0&id=9fce2250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fce2250",
  null
  
)

export default component.exports